import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentTemplate } from '../../../../../models/document.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalExcluirComponent } from '../../../components/modal-excluir/modal-excluir.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { SettingService } from '../../../../../services/setting.service';

@Component({
  selector: 'app-document-templates',
  templateUrl: './document-templates.component.html',
  styleUrl: './document-templates.component.scss'
})
export class DocumentTemplatesComponent implements OnInit {
  @ViewChild(ModalExcluirComponent) modalExcluirComponent!: ModalExcluirComponent;

  file: File | null = null;
  breadCrumbItems!: Array<{}>;
  documents: DocumentTemplate[] = [];

  documentForm!: FormGroup;

  public Collapsed = false;
  public firstCollapse = false;
  public secondCollapse = false;
  public bothColleaps = false;

  constructor(
    private toastService: ToastService,
    private fb: FormBuilder,
    public settingService: SettingService,
    private modalService: NgbModal
  ) {
    this.documentForm = this.fb.group({
      document: [null, [Validators.required]]
    })
  }

  ngOnInit(): void {

    this.breadCrumbItems = [
      { label: "Configurações" },
      { label: "Modelos Documentos", active: true },
    ];

    this.fetchDocumentTemplates();
  }

  onChange(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;
    }
  }

  onSubmit(documentoType: number): void {
    if (this.documentForm.valid) {

      const documentTemplate = new DocumentTemplate();
      documentTemplate.nomeArquivo = documentoType === 4 ? 'contrato' : 'proposta comercial';
      documentTemplate.tipoDeDocumento = documentoType;

      // Cria um FormData
      const formData = new FormData();
      formData.append('NomeArquivo', documentTemplate.nomeArquivo);
      formData.append('TipoDeDocumento', documentTemplate.tipoDeDocumento.toString());  // Certifique-se de converter para string, se necessário
      formData.append('Arquivo', this.file as Blob, this.file?.name);

      this.settingService.registerDocumentTemplate(formData).subscribe({
        next: (data) => {
          this.fetchDocumentTemplates();

          this.toastService.show("Cadastro com sucesso!", {
            classname: "bg-success text-light",
          });

          // setTimeout(() => {
          //   window.location.reload();
          // }, 1500)
        },
        error: (err) => {
          this.toastService.show("Erro ao tentar cadastrar documento!", {
            classname: "bg-danger text-light",
          });
        }
      });

    } else {
      this.documentForm.markAllAsTouched();
    }
  }

  downloadDocument(documentName: string): void {

    let url = this.documents.find(doc => doc.nomeArquivo == documentName);

    const a = document.createElement('a');
    a.href = url?.urlDownload!;
    a.download = `${documentName}_template.docx`;
    a.click();
    window.URL.revokeObjectURL(url?.urlDownload!);
  }

  private fetchDocumentTemplates(): void {
    this.settingService.getDocumentTemplates().subscribe({
      next: (data) => {

        this.documents = data || [];
      },
      error: (err) => {
        console.error('Erro ao buscar os documentos:', err);
        //this.errorMessage = 'Ocorreu um erro ao carregar os documentos.';
        //this.isLoading = false;
      }
    });
  }

  hasContratoDocumentContrato(): boolean {
    return this.documents.some(doc => doc.nomeArquivo === 'contrato');
  }

  hasPropostaDocumentContrato(): boolean {
    return this.documents.some(doc => doc.nomeArquivo === 'proposta');
  }

  openModal(documentName: string, documentType: number): void {
    this.modalExcluirComponent.payload = { documentName, documentType };
    this.modalExcluirComponent.openModal();
  }


  // Recebe o evento de exclusão do modal
  handleDelete(event: any): void {
    const { documentName, documentType } = event;

    this.settingService.deleteDocumentTemplate(documentName, documentType).subscribe({
      next: (data) => {
        this.toastService.show("Excluído com sucesso!", {
          classname: "bg-success text-light",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      error: (err) => {
        this.toastService.show("Erro ao tentar excluir documento!", {
          classname: "bg-danger text-light",
        });
      }
    });
  }
}
